import { Box, Button, Typography } from "@mui/material";
import { StyledBackgroundDiv } from "../../styles/common.style";

interface ApiErrorScreenProps {
    onRetry: () => void;
}

const ApiErrorScreen: React.FC<ApiErrorScreenProps> = ({ onRetry }) => {
    return (
        <StyledBackgroundDiv>
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "0 20px",
                }}
            >
                <Typography sx={{ fontSize: { xs: "2rem", md: "3rem" }, fontWeight: 900, color: "primary.main", marginBottom: "10px" }}>
                    Oups, une erreur est survenue
                </Typography>
                <Typography sx={{ fontSize: { xs: "1rem", md: "1.2rem" }, color: "primary.main", opacity: 0.8, marginBottom: "40px" }}>
                    Le contenu de cette page n'a pas pu être chargé. Réessayez dans quelques instants.
                </Typography>
                <Button onClick={onRetry} sx={{ border: "1px solid", borderColor: "primary.main" }}>
                    Réessayer
                </Button>
            </Box>
        </StyledBackgroundDiv>
    );
};

export default ApiErrorScreen;
